import { render } from "./TableComp.vue?vue&type=template&id=71d89864"
import script from "./TableComp.vue?vue&type=script&lang=js"
export * from "./TableComp.vue?vue&type=script&lang=js"

import "./TableComp.vue?vue&type=style&index=0&id=71d89864&lang=scss"
script.render = render

export default script